import { useState, useCallback } from 'react';

interface FirebaseImageProps {
  src: string;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
  thumbnail?: string;
  width?: number;
  height?: number;
}

const PLACEHOLDER_COLOR = '#e5e7eb'; // gray-200

export function FirebaseImage({
  src,
  alt,
  className = '',
  loading = 'lazy',
  thumbnail,
  width,
  height,
}: FirebaseImageProps) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  const handleLoad = useCallback(() => {
    setLoaded(true);
  }, []);

  const handleError = useCallback(() => {
    setErrored(true);
    setLoaded(true);
  }, []);

  if (errored) {
    return (
      <div
        className={className}
        style={{
          backgroundColor: PLACEHOLDER_COLOR,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: width || '100%',
          height: height || 200,
        }}
        role="img"
        aria-label={alt}
      >
        <span style={{ color: '#9ca3af', fontSize: 14 }}>Image indisponible</span>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width: width || '100%', height: height || 'auto' }}>
      {/* Placeholder anime */}
      {!loaded && (
        <div
          className={className}
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: PLACEHOLDER_COLOR,
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      )}

      <img
        src={src}
        srcSet={thumbnail ? `${thumbnail} 400w, ${src} 1200w` : undefined}
        sizes={thumbnail ? '(max-width: 600px) 400px, 1200px' : undefined}
        alt={alt}
        className={className}
        loading={loading}
        width={width}
        height={height}
        onLoad={handleLoad}
        onError={handleError}
        style={{
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease',
          display: 'block',
          width: width || '100%',
          height: height || 'auto',
        }}
      />
    </div>
  );
}
